import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import { buyBox } from "@signals"


export default function DIPBuyBox() {
    return <ToggleButtonSeeker
		sx={{ button: { px: 3 } }}
		value={buyBox.value ? 'YES' : 'NO'}
		tabs={[
			{ value: 'NO', label: 'All' },
			{ value: 'YES', label: 'Buy box' },
		]}
		onChange={(_, newValue) => buyBox.value = newValue === 'YES'}
	/>
}